import { css } from "@styled-system/css";
import { flex } from "@styled-system/patterns";

// More breathing room than the default "8" - the filter row was cramping five very
// different control types (text inputs, switches, a dropdown, a button) onto one baseline.
// flexWrap lets it break onto a second line on narrower screens instead of overflowing.
export const filterWrapperClass = flex({
	alignItems: "flex-end",
	flexWrap: "wrap",
	gap: "20",
	marginBottom: "20",
});

export const actionButtonsWrapperClass = flex({
	align: "center",
	gap: "8",
});

// Date filter group: a label above (matching the InputText/InputSwitch fields it sits next
// to) with the Dropdown + "Edit range" link in a row underneath.
export const dateFilterGroupClass = flex({
	direction: "column",
	alignItems: "flex-start",
	gap: "4",
});

export const dateFilterControlsRowClass = flex({
	alignItems: "center",
	gap: "12",
});

// Matches epic-ui's own label styling EXACTLY (InputText and InputSwitch both render their
// label via the same EpicP3Label token: Roboto 400, 12px/18px, color fontPrimary/shade.100) -
// first attempt here used 14px, which is why "Created" rendered visibly bigger than
// "Account Name" / "Guest orders only" next to it.
export const dateFilterLabelClass = css({
	display: "block",
	fontFamily: "default",
	fontWeight: "normal",
	fontSize: "12",
	lineHeight: "18",
	color: "shade.100",
});

export const switchScaleWrapperClass = css({
	"& .p-inputswitch": {
		width: "[56px !important]",
		height: "32 !important",
	},
	"& .p-inputswitch .p-inputswitch-slider:before": {
		width: "24 !important",
		height: "24 !important",
		marginTop: "-12 !important",
	},
	"& .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before": {
		transform: "[translateX(24px) !important]",
	},
});

// Brings a plain PrimeReact control (Dropdown, Calendar) up to the same rounded-corner,
// shade.40-bordered look as the epic-ui InputText boxes beside it. Plain inline style, not a
// css() class: PrimeReact's theme CSS targets the same element with equal selector specificity
// (".p-dropdown" / ".p-inputtext"), so a generated utility class can lose that tie depending on
// stylesheet order - an inline style always wins.
export const filterControlStyle = {
	borderRadius: "4px",
	borderColor: "var(--colors-shade-40)",
	height: "42px",
};

export const customRangeFieldClass = flex({
	direction: "column",
	alignItems: "flex-start",
	gap: "4",
});

export const customRangeFieldsRowClass = flex({
	alignItems: "flex-end",
	gap: "16",
});

export const dialogFooterClass = flex({
	justifyContent: "flex-end",
	gap: "8",
});

export const guestBadgeClass = css({
	display: "inline-block",
	paddingX: "8",
	paddingY: "2",
	borderRadius: "4",
	fontSize: "12",
	fontWeight: "bold",
	color: "shade.0",
	backgroundColor: "warning.100",
});

export const claimedGuestBadgeClass = css({
	display: "inline-block",
	paddingX: "8",
	paddingY: "2",
	borderRadius: "4",
	fontSize: "12",
	fontWeight: "bold",
	color: "shade.0",
	backgroundColor: "info.100",
});

// Deliberately the quietest badge in the column: an unattributed cart is a normal in-progress
// state, not something CS needs to act on, so it must not compete with the warning-coloured
// Guest badge that does signal work.
export const noBuyerYetBadgeClass = css({
	display: "inline-block",
	paddingX: "8",
	paddingY: "2",
	borderRadius: "4",
	fontSize: "12",
	fontWeight: "bold",
	color: "shade.60",
	backgroundColor: "shade.10",
});

export const accountBadgeClass = css({
	display: "inline-block",
	paddingX: "8",
	paddingY: "2",
	borderRadius: "4",
	fontSize: "12",
	fontWeight: "bold",
	color: "shade.0",
	backgroundColor: "success.100",
});
